import { render, staticRenderFns } from "./VerticalBarSkill.vue?vue&type=template&id=220c0b61&"
import script from "./VerticalBarSkill.vue?vue&type=script&lang=js&"
export * from "./VerticalBarSkill.vue?vue&type=script&lang=js&"
import style0 from "./VerticalBarSkill.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports